import { getTypographyStyles, SEM_BORDER_WIDTH_FORMS_DEFAULT, SYS_SPACE_FIXED_150, SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_LABEL, getMargins, SYS_BORDER_RADIUS_XS, SYS_SPACE_FIXED_450, SYS_SPACE_FIXED_25, SYS_SPACE_FIXED_50, SYS_SIZE_FIXED_600 } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
import styled, { css } from 'styled-components';
import { Icon } from '../../components/icon/index.js';
import { FormMessage } from '../form-message/index.js';
export const StyledCheckboxContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_50};
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledBox = styled.span `
  width: ${SYS_SIZE_FIXED_600};
  height: ${SYS_SIZE_FIXED_600};
  border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid
    ${(props) => props.theme.sem.color.forms.surface.control.default.stroke.idle};
  color: ${(props) => props.theme.sem.color.forms.foreground.control.selected.indicator.idle};
  background-color: ${(props) => props.theme.sem.color.forms.surface.control.default.fill.idle};
  box-sizing: border-box;
  border-radius: ${SYS_BORDER_RADIUS_XS};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: border-color, color, background-color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledIcon = styled(Icon) `
  transform: scale(0);
  visibility: hidden;
  transition-property: transform, visibility;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledTextContent = styled.div `
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  padding-top: ${SYS_SPACE_FIXED_25};
  align-items: flex-start;
  flex: 1 0 0;
  transition-property: color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  ${(props) => props.invalid &&
    css `
      & + ${StyledBox} {
        border-color: ${props.theme.sem.color.forms.surface.control.default
        .stroke.error};
        background-color: ${props.theme.sem.color.forms.surface.control.default
        .fill.error};
      }

      &:checked:not(:disabled) + ${StyledBox} {
        border-color: ${props.theme.sem.color.forms.surface.control.selected
        .stroke.error};
        background-color: ${props.theme.sem.color.forms.surface.control.selected
        .fill.error};
        color: ${props.theme.sem.color.forms.foreground.control.selected
        .indicator.error};
      }
    `}

  ${(props) => !props.invalid &&
    css `
      &:checked:not(:disabled) + ${StyledBox} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.stroke.idle};
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.fill.idle};
      }

      &:hover:not(:disabled) {
        + ${StyledBox} {
          border-color: ${(props) => props.theme.sem.color.forms.surface.control.default.stroke
        .interactive};
          background-color: ${(props) => props.theme.sem.color.forms.surface.control.default.fill
        .interactive};
        }
      }

      &:checked:hover:not(:disabled) + ${StyledBox} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.stroke
        .interactive};
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.fill
        .interactive};
        color: ${(props) => props.theme.sem.color.forms.foreground.control.selected.indicator
        .interactive};
      }

      &:disabled + ${StyledBox} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.default.stroke.disabled};
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.default.fill.disabled};
        cursor: not-allowed;
      }

      &:checked:disabled + ${StyledBox} {
        color: ${(props) => props.theme.sem.color.forms.foreground.control.selected.indicator
        .disabled};
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.stroke.disabled};
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.selected.fill.disabled};
        cursor: not-allowed;
      }
    `}

  &:checked + ${StyledBox} {
    ${StyledIcon} {
      visibility: visible;
      transform: scale(1);
    }
  }

  &:focus {
    outline: none;
  }

  &:focus + ${StyledBox} {
    outline: 2px solid Highlight;
    outline-style: auto;
    outline: 2px solid -webkit-focus-ring-color;
  }

  &:focus:not(:focus-visible) + ${StyledBox} {
    outline: none;
  }
`;
export const StyledLabel = styled.label `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_150};
  align-items: flex-start;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  ${(props) => !props.invalid &&
    css `
      &:has(${StyledInput}:disabled) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
        }
      }

      &:has(${StyledInput}:checked:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
        }
      }

      &:has(${StyledInput}:hover:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
        }
      }
    `}

  ${(props) => props.invalid &&
    css `
      color: ${props.theme.sem.color.forms.foreground.text.error};
    `}
`;
export const StyledAppendix = styled.div `
  padding-top: ${SYS_SPACE_FIXED_50};
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.appendix.disabled
    : props.theme.sem.color.forms.foreground.field.appendix.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-left: ${SYS_SPACE_FIXED_450};
`;
//# sourceMappingURL=index.styles.js.map